import React, { Component } from 'react';
import PropType from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './SkillListItem';
import FlatButton from 'material-ui/FlatButton';

import SkillActions from '../../actions/SkillActionCreator';
import SkillStore from '../../stores/SkillStore';
import UpIcon from "material-ui/svg-icons/hardware/keyboard-arrow-up";
import DownIcon from "material-ui/svg-icons/hardware/keyboard-arrow-down";

class SkillList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            skills: [],
            count: 0,
            page: 0,
            limit: 50,
            showButton: false,
            loading: false,
            fetchedAll: false
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        SkillStore.addChangeListener(this.onChange);
        SkillActions.getAll({limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        SkillStore.removeChangeListener(this.onChange);
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/skill/new' : '';

        return (
            <div ref="skillList">
                <ListView
                    title="Skills"
                    sortOptions={this.props.sortOptions}
                    sortAction={this.sort}
                    searchAction={SkillActions.search}
                    items={this.state.skills}
                    itemDecorator={ListItem}
                    newEntityUrl={newEntityUrl}
                />
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        )
    }

    onChange() {
        if (SkillStore.fetchedAll()) {
            this.setState({fetchedAll: true, loading: false});
        } else {
            const skills = SkillStore.getAll({limit: this.state.limit});
            if (!!skills) {
                if (skills.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                    this.setState({skills, loading: false});
                } else {
                    const mapped = skills.map(this.state.sortMapCriteria);
                    mapped.sort(this.state.sortCriteria);
                    const sortedSkills = mapped.map((el) => skills[el.index]);
                    this.setState({skills: sortedSkills, loading: false});
                }
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'validFrom':
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.validFrom)});
                break;
            case 'code':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.code});
                break;
            case 'level':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.level});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        SkillActions.getAll({sort: options.sort});
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = this.state.page + 1;
        SkillActions.getAll({page, limit: this.state.limit});
        this.setState({page, loading: true});
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.skillList.clientHeight) {
            this.loadNextPage();
        }
    }
}

SkillList.contextTypes = {
        auth: PropType.object.isRequired
};

SkillList.defaultProps = {
    sortOptions: [
        {label: 'Name', value: 'name'},
        {label: 'Valid from', value: 'validFrom'},
        {label: 'Code', value: 'code'},
        {label: 'Level', value: 'level'}
    ]
};

export default SkillList;
